namespace Dashboard {
    export enum BookingStatus {
        Pending = 1,
        Receipted = 2,
        Ticketed = 4,
        Complete = 5,
        CancelledByCustomer = 6,
        Void = 7,
        HoldAwaitingConfirmation = 8,
        DeclinedByEstab = 9,
        ConfirmedByEstab = 10,
        CancellationConfirmedByEstab = 11,
        CancellationDeclinedByEstab = 12,
        FailedSecurityCheck = 13,
        HoldSwap = 14
    }
}
